import {createAction,props} from '@ngrx/store';


export const LOADING_RELATED_PRODUCTS = '[RELATED-PRODUCTS] Loading related products items';
export const LIST_RELATED_PRODUCTS = '[RELATED-PRODUCTS] List related products items';
export const ERROR_RELATED_PRODUCTS = '[RELATED-PRODUCTS] Related Products Loaded Error';
export const CANCEL_RELATED_PRODUCTS_REQUEST = '[RELATED-PRODUCTS] Cancel related products request';
export const RESET_RELATED_PRODUCTS = '[RELATED-PRODUCTS] Reset related products items';

export const LoadingRelatedProductsAction = createAction(
  LOADING_RELATED_PRODUCTS,
  props<{payload:any}>()
);
export const ListRelatedProductsAction = createAction(
  LIST_RELATED_PRODUCTS,
  props<{data: any}>()
);
export const ResetRelatedProductsAction = createAction(RESET_RELATED_PRODUCTS);
export const ErrorRelatedProductsAction = createAction(ERROR_RELATED_PRODUCTS);
export const CancelRelatedProductRequestAction = createAction(CANCEL_RELATED_PRODUCTS_REQUEST);
